export default __webpack_public_path__ + "static/media/location_duotone.0c3a6ffc.svg";